import OrderableImagePlaceholderIcon from '@assets/icons/orderable-image-placeholder.svg';
import React from 'react';
import { CachedImage } from '@usepepper/ui/atoms/cached-image';
import { createStyles } from '@/contexts/theme-context';
import { ImageProps } from 'expo-image';
import { ImageStyle, StyleProp, View, ViewStyle } from 'react-native';
import { Spacing } from '@usepepper/sprout-kit';

interface Props {
  alt: string;
  badge?: React.ReactNode;
  badgeStyle?: StyleProp<ViewStyle>;
  cachePolicy?: ImageProps['cachePolicy'];
  contentFit?: ImageProps['contentFit'];
  hidePlaceholderImages?: boolean;
  imageURLs: string[];
  size: Spacing;
  style?: StyleProp<ImageStyle>;
}

export const ItemImage: React.FC<Props> = ({
  alt,
  badge,
  badgeStyle,
  cachePolicy,
  contentFit = 'contain',
  imageURLs,
  hidePlaceholderImages = false,
  size,
  style,
}) => {
  const [styles, theme] = useStyles();

  const imageSize = theme.sk.spacing[size];
  const imageURL = imageURLs[0];

  return (
    <>
      {imageURL ? (
        <CachedImage
          alt={alt}
          cachePolicy={cachePolicy}
          contentFit={contentFit}
          recyclingKey={imageURL}
          source={{ uri: imageURL }}
          style={[{ height: imageSize, width: imageSize }, styles.image, style]}
        />
      ) : !hidePlaceholderImages ? (
        <View style={[styles.image, { height: imageSize, width: imageSize }]}>
          <OrderableImagePlaceholderIcon
            // Subtract 1 to account for the border
            height={imageSize - 1}
            width={imageSize - 1}
          />
        </View>
      ) : null}
      {badge ? <View style={[styles.badge, badgeStyle]}>{badge}</View> : null}
    </>
  );
};

const useStyles = createStyles((theme) => ({
  badge: {
    left: 2,
    position: 'absolute',
    top: 2,
  },
  image: {
    alignSelf: 'center',
    borderColor: theme.sk.color.border.image,
    borderRadius: 8,
    borderWidth: 1,
  },
}));
